import { Error } from './Error';

export const BackendError = () => {
  return <Error title={'500'} subtitle={'We have an internal server error!'} />;
};
